import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import HhAmenties from '../json-pages/HhAmenties';
import HhBedRooms from '../json-pages/HhBedRooms';
import HhInfo from '../json-pages/HhInfo';
import HhPolicies from '../json-pages/HhPolicies';
import HhPrimary from '../json-pages/HhPrimary';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/amentity`} component={HhAmenties} />
      <Route path={`${match.url}/bedrooms`} component={HhBedRooms} />
      <Route path={`${match.url}/information`} component={HhInfo} />
      <Route path={`${match.url}/policies`} component={HhPolicies} />
      <Route path={`${match.url}/primary`} component={HhPrimary} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
